module.exports = "<p>monitored-train-sim works!</p>\n";